import { createAction } from 'redux-act';
import { TLegacyErrors } from '@alycecom/services';

import { IClaimResponse } from './claim.types';

const PREFIX = 'RECIPIENT/CLAIM';

export const claimRequest = createAction<string>(`${PREFIX}/CLAIM_REQUEST`);
export const claimSuccess = createAction<IClaimResponse>(`${PREFIX}/CLAIM_SUCCESS`);
export const claimFail = createAction<TLegacyErrors>(`${PREFIX}/CLAIM_FAIL`);

export const setShowResubscribeModal = createAction<boolean>(`${PREFIX}/SET_SHOW_RESUBSCRIBE_MODAL`);
